import {BaseSearchDTO} from "../baseSearchDTO.interface";

export interface VehicleFaultStatusSearchDTO extends BaseSearchDTO {
  filters?: {
  };
}
